
import type { FC } from 'react';
import { memo, useCallback, useState } from 'react';

import { useDrop } from 'react-dnd';
import classNames from 'classnames';
import { useDragAndDrop } from '@/utils/useDragAndDrop';
import { IDragQuestionProps } from '@/utils/ctype';
import Drag from '../../../components/Drag';
import Drop from '../../../components/Drop';
import KeyboardTip from '../../../components/KeyboardTip';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';



const Container: FC<IDragQuestionProps> = memo(function Container(props) {
  
  const { data , saveAnswerHandle, pageData, loadAnswered, answerMap, keyIndex, setShowDragFieldHandle, setFocusIndexHandle} = props;
  const { collect_option, question_title, list} = data || {};

  const {
    dustbins,
    boxes,
    recoverOption,
    recoverBlank,
    handleDrop,
    handleDropOptionList
  } = useDragAndDrop(data, {optionHidden: 'visible', type: 'matchTitle', accepts: ['matchTitle', 'matchBlank'], blankType: 'matchBlank', saveAnswerHandle, pageData, loadAnswered, answerMap});

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ['matchTitle', 'matchBlank'],
    drop: handleDropOptionList,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  return (
    <div className={style.box}>
      <KeyboardTip></KeyboardTip>
      <div className={style.content}>
        <div className={style.question}>
          <div className={style.questionTitle} data-key={`question.question.${keyIndex}.question_title`}><HtmlParser htmlString={question_title}></HtmlParser></div>
          {dustbins.map(({ accepts, lastDroppedItem, data, type, uid }, index) => (
            <div className={style.questionItem} key={index}>
              <span className={style.questionText} data-key={`question.question.${keyIndex}.list.${index}.title`}><HtmlParser htmlString={list[index].title}></HtmlParser></span>
              <div className={style.blankBox}>
                <Drop
                  accept={accepts}
                  lastDroppedItem={lastDroppedItem}
                  onDrop={(item) => handleDrop(index, item)}
                  index={index}
                  data={data}
                  recoverOption={recoverOption}
                  recoverBlank={() => recoverBlank(index)}
                  type={type}
                  blankClass={style.blank}
                  optionClass={style.option}
                  id={`question${data.number}`}
                  uid={uid}
                  onFocus={() => setFocusIndexHandle&&setFocusIndexHandle(data.number)}
                />
              </div>
            
            </div>
          ))}
        </div>

        <div className={style.answer}>
          <div className={style.optionTitle} data-key={`question.question.${keyIndex}.collect_option.title`}><HtmlParser htmlString={collect_option.title}></HtmlParser></div>
          <div className={classNames(style.answerList, isOver ? style.isOver : '')} ref={drop}>
            {boxes.map(({ data, type, display, optionHidden, uid}, index) => (
              <div className={style.answerItem} key={index}>
                <Drag data={data} type={type} index={index} display={display} optionHidden={optionHidden} uid={uid} setShowDragFieldHandle={setShowDragFieldHandle}/>
              </div>
            ))}
          </div>
          
        </div>
      </div>
      
    </div>
  );
});

export default Container;